import { CalculateVenueCo2Mapper } from '../co2/mapper';
import { CalculateVenueEnvMapper } from '../env/mapper';
import { CalculateVenueEssMapper } from '../ess/mapper';
import { SummaryImpactForAllProjectsDto } from './dto.schema';

export class SummaryImpactForAllProjectsMapper {
  static dtoToEntity(dto: SummaryImpactForAllProjectsDto) {
    return dto.data.map((item) => {
      return {
        projectId: item.id,
        calculate: {
          co2:
            item.results.co2 &&
            CalculateVenueCo2Mapper.dtoToEntity(item.results.co2),
          env:
            item.results.env &&
            CalculateVenueEnvMapper.dtoToEntity(item.results.env),
          ess:
            item.results.ess &&
            CalculateVenueEssMapper.dtoToEntity(item.results.ess),
        },
      };
    });
  }
}
